import ListTileLayer from "../../layouts/ListTileLayer"
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers';
import RouteIcon from '@mui/icons-material/Route';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import GrainOutlinedIcon from '@mui/icons-material/GrainOutlined';
import FilterCenterFocusRoundedIcon from '@mui/icons-material/FilterCenterFocusRounded';
import CenterFocusWeakRoundedIcon from '@mui/icons-material/CenterFocusWeakRounded';


import { useRef, useState } from "react";

export const ControlPoiLayerMap = ({ onClick, selected }) => {

    const [open, setOpen] = useState(false)
    const ref = useRef(null);

    const onOpen = () => {
        setOpen(true)
    }
    const onClose = () => {
        setOpen(false)
    }
    const _onClick = (val) => {
        onClose()
        onClick(val)
    }
    return (
        <Box style={
            {
                position: 'fixed',
                display: 'block',
                backdropFilter: 'blur(10px)',
                border: "2px solid rgba(0,0,0,0.2)",
                borderRadius: 5,
                top: 10,
                right: 10,
                width: 32,
                height: 32,
                zIndex: 999,
            }
        }
            ref={ref}
        >
            <IconButton edge="end" size="small"
                style={{ backgroundColor: 'white', borderRadius: 5, }}
                onClick={onOpen}>
                <LayersIcon fontSize="inherit" />
            </IconButton>
            <Menu
                open={open}
                anchorEl={ref.current}
                onClose={onClose}
                PaperProps={{
                    sx: { width: 200, maxWidth: '100%' }
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {
                    ListTileLayer.map((value, index) =>
                        <MenuItem
                            sx={{ color: 'text.default', fontWeight: selected === value.id ? 600 : 300 }}

                            onClick={() => { _onClick(value) }}
                            key={'MenuItem' + index}
                        >
                            {
                                value.name
                            }
                        </MenuItem>
                    )
                }
            </Menu>
        </Box>
    )
}

export const ControlPoiCluster = ({ show, onClick }) => {

    return (<Box style={
        {
            position: 'fixed',
            display: 'block',
            backdropFilter: 'blur(10px)',
            border: "2px solid rgba(0,0,0,0.2)",
            borderRadius: 5,
            top: 235,
            right: 10,
            width: 32,
            height: 32,
            zIndex: 999,
        }
    }
    >
        <IconButton
            edge="end" size="small"
            style={{ backgroundColor: 'white', borderRadius: 5, }}
            onClick={onClick}
        >
            <GrainOutlinedIcon color={show ? "action" : "disabled"} fontSize="inherit" />
        </IconButton>
    </Box>
    )
}